import { SelectedObjectUI } from '@services/engine/types'
import { put } from 'redux-saga/effects'

import { setSelectedObjectUI as set } from '@store/slices/sceneSlice'

export default function* setSelectedObjectUI(dataEvent: SelectedObjectUI) {
  yield put(set(dataEvent))
}
